import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getRoutes } from './helper';
import { SecureRoute, LoginCallback } from '@okta/okta-react';
const NotFound = lazy(() => import('../screens/no-match'));

const areEqual = (prevProps, nextProps) => {
  return prevProps?.roles?.length === nextProps?.roles?.length;
};

const defaultHomePath = '/refcampaigns';
const Routes = ({ roles }) => {
  return (
    <Switch>
      {getRoutes(roles)?.map((route) => (
        <SecureRoute key={route.name} component={route.component} path={route.path} exact />
      ))}
      <Route path="/implicit/callback" component={LoginCallback} exact />
      <Route exact path="/">
        <Redirect to={defaultHomePath} />
      </Route>
      {roles.length > 0 && <SecureRoute path="/404" component={NotFound} exact />}
      {roles.length > 0 && <Redirect to="/404" />}
    </Switch>
  );
};

Routes.propTypes = {};

export default React.memo(Routes, areEqual);
